// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-container {
  position: relative;
  height: 100%;
  min-height: 200px; /* optional safeguard */
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/custom/app-graph/app-graph.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA,EAAA,uBAAA;EACA,WAAA;AACF","sourcesContent":[".chart-container {\n  position: relative;\n  height: 100%;\n  min-height: 200px; /* optional safeguard */\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
